import { Icon, IconProps } from ".";

export const Argent = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M14.0538 4.68628H9.93206C9.79164 4.68628 9.68427 4.80192 9.68427 4.94234C9.60167 8.93189 7.57798 12.7232 4.10055 15.4077C3.99317 15.4903 3.96839 15.6555 4.04273 15.7711L6.45463 19.2072C6.53723 19.3229 6.69417 19.3477 6.80981 19.2651C8.99043 17.5966 10.7415 15.5894 11.997 13.3592C13.2608 15.5894 15.0119 17.5966 17.1843 19.2651C17.2999 19.3477 17.4569 19.3229 17.5395 19.2072L19.9514 15.7711C20.034 15.6555 20.0092 15.4985 19.8935 15.4077C16.4079 12.7232 14.3924 8.94015 14.3098 4.94234C14.3016 4.80192 14.1859 4.68628 14.0538 4.68628Z" />
    </Icon>
  );
};
